import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
let TaskAnalysisService = class TaskAnalysisService {
    constructor(workspaceApi) {
        this.workspaceApi = workspaceApi;
        this.getTotalTask = this.workspaceApi.getTotalTask;
    }
    async getTaskTrend(params) {
        const res = await this.workspaceApi.getTaskTrend(params);
        return res;
    }
    async getErrorTaskInfos(params) {
        const res = await this.workspaceApi.getErrorTaskInfos(params);
        return res;
    }
    async getTaskType(params) {
        const res = await this.workspaceApi.getTaskType(params);
        return res;
    }
    async getTaskStatus(params) {
        const res = await this.workspaceApi.getTaskStatus(params);
        return res;
    }
    async getErrorMax(params) {
        const res = await this.workspaceApi.getErrorMax(params);
        return res;
    }
    async getTaskMax(params) {
        const res = await this.workspaceApi.getTaskMax(params);
        return res;
    }
};
TaskAnalysisService = __decorate([
    injectable(),
    __param(0, inject(Symbols.WorkspaceApi)),
    __metadata("design:paramtypes", [Object])
], TaskAnalysisService);
export { TaskAnalysisService };
